export default {
  studentUnitLearn: {
    id: "",
    studentEnroll: null,
    studentEnrollDetail: null,
    courseOutlineUnit: null,
    vdoSetUnit: null,
    unitSeq: null,
    totalVdoLength: null,
    totalLearnTime: null,
    learnPercent: null,
    studentTopicLearns: [],
  },

  studentUnitLearns: [],
  processing: false,
  error: null,
  success: null,
}



